import { IconTruck } from '@veneer/core';

import { NamespacesI18n } from '@storefront/i18n';
import classNames from 'classnames';
import currency from 'currency.js';

import { useTranslation } from 'react-i18next';
import ModalPrinterComparison from '@storefront/app/v2/pdp-config/shared-components/modals/modal-printer-comparison/modal-printer-comparison';

import styles from './selection-button.module.scss';

export const renderExtraInfo = (
  outOfStock: boolean,
  backOrderShipping: boolean
) => {
  const { t } = useTranslation(NamespacesI18n.PDP_CONFIG);
  return (
    <div className={styles['extra-informative-label']}>
      {outOfStock && (
        <div data-testid="out-of-stock-label">
          <div className={styles['background-overlay']} />
          <div className={styles['label']}>
            <p>{t('pdpConfig.outOfStock.label1')}</p>
            <ModalPrinterComparison
              noFirstText={true}
              secondText="options"
              underlineLink={true}
            />
            <p>{t('pdpConfig.outOfStock.label2')}</p>
          </div>
        </div>
      )}
      {backOrderShipping && (
        <div data-testid="back-order-label">
          <div className={styles['background-overlay']} />
          <div
            className={classNames(styles['label'], styles['centered-label'])}
          >
            <IconTruck
              className={styles['icon-checkmark']}
              size={24}
              id="checkmark-icon"
              color={'gray12'}
            />
            <p
              dangerouslySetInnerHTML={{
                __html: t('pdpConfig.backOrder.label'),
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export const renderBadge = (
  popular: boolean,
  outOfStock: boolean,
  backOrderShipping: boolean
) => {
  const { t } = useTranslation(NamespacesI18n.PDP_CONFIG);
  return (
    <div className={styles['badge-container']}>
      {popular && !outOfStock && !backOrderShipping && (
        <span
          className={styles['popular-badge-text']}
          data-testid="popular-badge"
        >
          Popular
        </span>
      )}
      {outOfStock && !backOrderShipping && (
        <span
          className={styles['out-of-stock-badge-text']}
          data-testid="out-of-stock-badge"
        >
          {t('pdpConfig.outOfStock.title')}
        </span>
      )}
      {backOrderShipping && (
        <span
          className={styles['back-order-badge-text']}
          data-testid="back-order-badge"
        >
          {t('pdpConfig.backOrder.title')}
        </span>
      )}
    </div>
  );
};

export const renderPrice = (checked: boolean, price: number | currency) => {
  const { t } = useTranslation(NamespacesI18n.PDP_CONFIG);

  const handleOptionPrice = () => {
    if (checked) {
      return t('pdpConfig.optionPrice.included');
    }

    if (price === 0) {
      return t('pdpConfig.optionPrice.included');
    }

    return t('pdpConfig.optionPrice.price', {
      price: currency(price, {
        pattern: '+!#',
        negativePattern: '-!#',
      }).format(),
    });
  };

  return (
    <div className={styles['price-container']}>
      <span
        id="radio-button-price"
        data-testid="radio-button-price"
        className={classNames(
          styles['text-container'],
          checked ? 'caption-regular' : 'body-regular'
        )}
      >
        {handleOptionPrice()}
      </span>
    </div>
  );
};
